// extracted by mini-css-extract-plugin
export default {"wrapper":"GeneratorSelectList_wrapper__NSmSR","cols2":"GeneratorSelectList_cols2__24VZ3","cols3":"GeneratorSelectList_cols3__zc9o0"};